import { APP_VERSION } from '../version'

/** Footer mit App-Version und Copyright (analog SkillMy). */
export function AppFooter({ className = '' }: { className?: string }): React.JSX.Element {
  return (
    <footer className={`pt-4 text-center text-xs ${className}`} style={{ color: 'var(--color-muted)' }}>
      Version {APP_VERSION} · © 2026 by Gerd Ralf Rehn
    </footer>
  )
}
